var map = {
	"./b026/footer/footer": 593,
	"./b027site/footer/footer": 594,
	"./b027sport/footer/footer": 595,
	"./bet365luck/footer/footer": 596,
	"./betl/footer/footer": 597,
	"./common/footer/footer": 598,
	"./dafa/footer/footer": 599,
	"./taiyangcheng018/footer/footer": 600,
	"./yongligao/footer/footer": 601
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 655;


//////////////////
// WEBPACK FOOTER
// ./src/components/different ^\.\/.*\/footer\/footer$
// module id = 655
// module chunks = 31